(($, window, undefined) => {
  if (window.mg === undefined)
    window.mg = {};

  if (window.mg.ui === undefined)
    window.mg.ui = {};

  const _ = window.mg;

  class HeaderMomentShowHideObserver {
    constructor(element) {
      abstractObserver(this, element);

      this.direction     = '';
      this.lastScrollTop = $(window).scrollTop();

      this.init();
    }

    init() {
      this.delta         = 5;
      this.defaultState  = true;

      this.initOffset();

      return this;
    }

    initOffset() {
      const cb = () => {
        const $headerAds = $('.header-ads', this.element);
        const $headerBar = $('.header-main', this.element);

        this.heightAds = $headerAds.length ? $headerAds[0].getBoundingClientRect().height : 0;
        this.heightBar = $headerBar.length ? $headerBar[0].getBoundingClientRect().height : 0;
        this.offset    = this.heightAds + this.heightBar;

        this.element.parent().css('padding-top', this.offset);

        if (!this._initOffsetCB && this.lastScrollTop > this.offset && this.heightAds > 0) {
          this._initOffsetCB = true;
          setTimeout(() => { this.element.removeClass('header-sticky-absolute'); }, 100);
        }
      };

      if (!this._adsObserver) {
        this._adsObserver = new MutationObserver((mutationsList, observer) => {
          cb();
        });

        this._adsObserver.observe($('.advertising-content', $('.header-ads', this.element))[0], { attributes: true, childList: true, subtree: true });
      }

      cb();
    }

    destroy() {
      this.element.removeClass('header-moved-up');
      this.element.addClass('header-sticky-absolute');

      return this;
    }

    checkDirection() {
      const nowScrollTop = $(window).scrollTop();

      if (Math.abs(this.lastScrollTop - nowScrollTop) >= this.delta) {
        if (nowScrollTop > this.lastScrollTop) {
          this.direction = 'down';
        } else {
          this.direction = 'up';
        }

        this.lastScrollTop = nowScrollTop;
      }

      return this;
    }

    check() {
      const navigationOpen = $(document.body).hasClass('navigation-open');

      if (navigationOpen) {
        return this;
      }

      const scrollTop = $(window).scrollTop();
      this.checkDirection();

      const hasAbsolute = this.element.hasClass('header-sticky-absolute');
      const hasMovedUp  = this.element.hasClass('header-moved-up');

      if (this.direction == 'down') {
        switch (true) {
          case (scrollTop >= this.offset && hasAbsolute && !hasMovedUp):
            this.element.addClass('header-moved-up');
            setTimeout(() => { this.element.removeClass('header-sticky-absolute'); }, 100);
            break;

          case (scrollTop >= this.offset && !hasAbsolute && !hasMovedUp):
            this.element.addClass('header-moved-up');
            break;
        }
      } else if (this.direction == 'up') {
        const isHigher = window.matchMedia('(min-height: 900px)').matches;

        switch (true) {
          case (scrollTop >= this.offset && hasMovedUp):
            this.element.removeClass('header-moved-up');
            break;

          case (scrollTop <= this.heightAds && !hasAbsolute && !isHigher):
            this.element.removeClass('header-moved-up');
            this.element.addClass('header-sticky-absolute');
            break;

          case (scrollTop <= this.heightAds && !hasAbsolute && isHigher):
            this.element.removeClass('header-moved-up');
            this.element.addClass('header-sticky-absolute');
            break;

          case (scrollTop == 0 && !hasAbsolute && isHigher):
            this.element.removeClass('header-moved-up');
            this.element.addClass('header-sticky-absolute');
            break;
        }
      }

      return this;
    }
  }

  class Header {
    constructor(element, config, observers) {
      this.element = element;
      this.config  = config;

      this.observers = observers && $.isPlainObject(observers) ? observers : {};

      this.viewport = 'xs';
      this.checkViewport();
    }

    checkViewport() {
      const width = $(window).width();

      if (width > this.config.breakpointsMap['sm'] && this.observers['sm'] && this.observers['sm'].length) {
        this.prevViewport = this.viewport;
        this.viewport     = 'sm';
        return this;
      }

      if (width > this.config.breakpointsMap['md'] && this.observers['md'] && this.observers['md'].length) {
        this.prevViewport = this.viewport;
        this.viewport     = 'md';
        return this;
      }

      if (width > this.config.breakpointsMap['lg'] && this.observers['lg'] && this.observers['lg'].length) {
        this.prevViewport = this.viewport;
        this.viewport     = 'lg';
        return this;
      }

      if (width > this.config.breakpointsMap['xl'] && this.observers['xl'] && this.observers['xl'].length) {
        this.prevViewport = this.viewport;
        this.viewport     = 'xl';
        return this;
      }

      this.prevViewport = this.prevViewport ? this.viewport : this.prevViewport;
      this.viewport = 'xs';
      return this;
    }

    notify() {
      if (this.prevViewport) {
        this.observers[this.prevViewport].forEach((observer) => {
          observer.destroy();
        });

        this.prevViewport = null;
      }

      this.observers[this.viewport].forEach((observer) => {
        observer.check();
      });

      return this;
    }

    update() {
      for (let viewport in this.observers) {
        this.observers[viewport].forEach((observer) => {
          observer.destroy();
        });
      }

      this.prevViewport = null;

      this.observers[this.viewport].forEach((observer) => {
        observer.reinit();
      });

      return this;
    }
  }

  const abstractObserver = (target, element) => {
    target.element      = element;
    target.defaultState = true;

    target.reinit = () => {
      target
        .destroy()
        .init()
        .check();
    };
  };

  const detectObservers = (element) => {
    const observers = {
      xs: []
    };

    // ------------------------ xs -------------------------
    // Sticky top
    if (element.hasClass('header-sticky-top')) {
      if (element.hasClass('header-show-hide')) {
        observers['xs'].push(new HeaderMomentShowHideObserver(element));
      }
    }

    return observers;
  };

  const init = (target) => {
    const $target = $(target);

    if (!$target || $target.length !== 1 || $target.data('Header')) return;

    const baseConfig = {
      breakpointsMap: {
        md: 768,
        sm: 576,
        lg: 992,
        xl: 1200
      }
    };

    const config    = $.extend(true, {}, baseConfig, $target.data());
    const observers = detectObservers($target);

    $target.data('Header', new Header($target, config, observers));

    let resizeTimeOutId;
    let windowW = window.innerWidth;

    const $window = $(window);

    $window
      .on('load.ui-header', () => {
        $window
          .on('scroll.ui-header', (e) => {
            $target
              .data('Header')
              .notify();
          })
          .on('resize.ui-header orientationchange.ui-header', (e) => {
            if (resizeTimeOutId) clearTimeout(resizeTimeOutId);

            resizeTimeOutId = setTimeout(() => {
              $target
                .data('Header')
                .checkViewport();
            }, 100);
          });

        $window
          .on('resize.ui-header orientationchange.ui-header', () => {
            if (window.innerWidth === windowW) return;

            windowW = window.innerWidth;

            if (resizeTimeOutId) clearTimeout(resizeTimeOutId);

            resizeTimeOutId = setTimeout(() => {
              $target
                .data('Header')
                .update();
            }, 100);
          });
      });
  };

  _.ui.header = {
    init
  };
})(jQuery, window);
